import { refreshBoxPickerCredentials } from '#pplx/frontend/apps/ask/queries/mutations/connectorMutations.js';
import { getUserSettingsQueryKey } from '#pplx/frontend/apps/ask/queries/query-keys/userKeys.js';
import { useMutation, useQueryClient } from '@tanstack/react-query';
export function useRefreshBoxPickerCredentials({ reason, }) {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: ({ connectionUuid }) => refreshBoxPickerCredentials({ connectionUuid, reason }),
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: getUserSettingsQueryKey({ skipConnectorPickerCredentials: false }),
            });
        },
    });
}
//# sourceMappingURL=useRefreshBoxPickerCredentials.js.map